import React, { useState } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';

import { BsGithub, BsInstagram } from 'react-icons/bs';
import { FiActivity} from 'react-icons/fi';
import { AiOutlineCloseCircle,AiFillLinkedin } from 'react-icons/ai';
import { images } from '../../constants';
import './Navbar.scss';

const Navbar = () => {

  const [open, setOpen] = useState(false);

  const handleChange = () => {
    setOpen(!open);
  };
  console.log(open);

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <FiActivity/>
      </div>
      <ul className="app__navbar-links">
        {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a href={`#${item}`}>{item}</a>
          </li>
        ))}
      </ul>

      <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={handleChange} />
        
{
  open && (
    <div>
      <AiOutlineCloseCircle onClick={handleChange}/>
      <ul>
              {['home', 'about', 'work', 'skills', 'contact'].map((item) => (
                <li key={item}>
                  <a onClick={handleChange}  href={`#${item}`}>
                    {item}
                  </a>
                </li>
              ))}
            </ul>
      <li className='media_icon'>
      <a  href='https://www.instagram.com/_jeffry_____/'>
       <BsInstagram />
    </a>
   
    <a href='https://github.com/salmanpoomonmlp'>
                  <BsGithub />
                </a>

                <a href='www.linkedin.com/in/salman-faris-3917ba28b'>
        <AiFillLinkedin/>
      </a>
                </li>
    </div>
  )
}
       
      </div>
    </nav>
  );
};

export default Navbar;